import { createReducer, createAction } from "redux-act";

export const reducerName = "dateFilter";

export type DateFilterState = {
  conditions?: {
    [key: string]: string;
  };
  layers?: {
    [key: string]: string[];
  };
};

type Condition = { name: string; condition: string };

const initialState: DateFilterState = {};

export const clearDateFilterConditions = createAction("date-filter/clear-conditions");

export const updateDateFilterConditions = createAction<Condition[]>("date-filter/update-conditions");

export const updateDateFilterLayers = createAction<DateFilterState["layers"]>("date-filter/update-conditions");

export const reducer = createReducer({}, initialState);

reducer.on(updateDateFilterConditions, (state, payload) => ({
  ...state,
  conditions: payload.reduce(
    (acc, condition) => ({
      ...acc,
      [condition.name]: acc[condition.name] ? `${acc[condition.name]} && ${condition.condition}` : condition.condition,
    }),
    {},
  ),
}));

reducer.on(updateDateFilterLayers, (state, payload) => ({
  ...state,
  layers: payload,
}));

reducer.on(clearDateFilterConditions, () => initialState);
